/* eslint-disable import/no-unresolved */
import React from 'react';

import Lightbox from 'yet-another-react-lightbox';
import {
  Captions,
  Download,
  Fullscreen,
  Video,
  Zoom,
} from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/styles.css';
import { Slide } from 'yet-another-react-lightbox/types';

import { AttachmentFile } from '@qality/common-model';

import './YetAnotherLightbox.scss';

type Props = {
  files: AttachmentFile[];
  mediaIndex: number;
  isOpen: boolean;
  dialogClose: () => void;
};

export default function YetAnotherLightbox({
  files,
  mediaIndex,
  isOpen,
  dialogClose,
}: Props): JSX.Element {
  const [open, setOpen] = React.useState(isOpen);

  const mapFilesToSlides = (filesArg: AttachmentFile[]): Array<Slide> => {
    return filesArg.map((file: AttachmentFile) => {
      return file.mimeType.startsWith('video/')
        ? mapVideoFileToSlide(file)
        : mapImageFileToSlide(file);
    });
  };

  const mapImageFileToSlide = (file: AttachmentFile): Slide => {
    return {
      src: file.content,
      alt: file.filename,
      download: file.content,
      title: file.filename,
      description: file.filename,
      type: 'image',
    };
  };

  const mapVideoFileToSlide = (file: AttachmentFile): Slide => {
    return {
      type: 'video',
      sources: [
        {
          src: file.content,
          type: file.mimeType,
        },
      ],
      title: file.filename,
      description: file.filename,
      download: file.content,
    };
  };

  const handleClose = () => {
    setOpen(false);
    dialogClose();
  };

  return (
    <Lightbox
      open={open}
      index={mediaIndex}
      close={() => handleClose()}
      slides={mapFilesToSlides(files)}
      plugins={[Zoom, Download, Fullscreen, Video, Captions]}
    />
  );
}
